import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { SendOtpCodePayload } from "../type";

function useSendPasswordOtp() {
  return useMutation({
    mutationFn: (command: SendOtpCodePayload) => {
      return authService.sendResetPasswordOtp(command);
    },
  });
}

export default useSendPasswordOtp;
